import { API, AuthAPI } from "../api/axios";
import TokenService from "./token.service";
const END_POINT_PASSWORD = "/password/email";
const END_POINT_RESETPASSWORD = "/password/reset";
const END_POINT_PROFILE = "/user"
class AuthService {
    login({ email, password }) {
        return API.post("/login-admin", {
            email,
            password,
        }).then((response) => {
            if (response.data.access_token) {
                //localStorage.setItem('user', JSON.stringify(response.data));
                TokenService.setUser(response.data);
                window.localStorage.setItem(
                    "token",
                    response.data.access_token
                );
            }

            return response.data;
        });
    }
    get(id) {
        return API.get(`${END_POINT_PROFILE}/${id}`);
    }
    update(id,data) {
        return API.post(`${END_POINT_PROFILE}/${id}`,data);
    }
    logout() {
        // localStorage.removeItem('user');
        TokenService.removeUser();
    }

    password(data) {
        return AuthAPI.post(END_POINT_PASSWORD, data);
    }

    resetPassword(data) {
        return AuthAPI.post(END_POINT_RESETPASSWORD, data);
    }
}

export default new AuthService();
